import { FunctionComponent, useState } from "react";
import { Col, Image } from "react-bootstrap";
import { Employee } from "../../services/EventService";
import SpeakerDetailModal from "./SpeakerDetailModal";

interface SpeakerProps {
    speaker: Employee;
    agendaModalVisible: boolean;
}

const VITE_STRAPI_IMAGE_BASE_URL: string = import.meta.env.VITE_STRAPI_IMAGE_BASE_URL;

const SpeakerElement: FunctionComponent<SpeakerProps> = (props) => {
    const { speaker } = props;
    const { agendaModalVisible } = props;
    const [showDetail, setShowDetail] = useState(false);

    return (
        <>
            <SpeakerDetailModal show={showDetail} setShowDetail={setShowDetail} speaker={speaker} />
            <Col>
                {speaker.image &&
                <div>
                    <Image className="rounded-circle my-3 event__speaker-image" width={120} height={120} src={`${VITE_STRAPI_IMAGE_BASE_URL}${speaker.image.url}`} />
                </div>
                }
                {(speaker.resume || speaker.linkedin_url) && !agendaModalVisible &&
                    <p style={{ cursor: "pointer" }} onClick={() => (setShowDetail(true))} className="p-0 my-0 event__speaker-name text-decoration-underline">{speaker.title} {speaker.firstname} {speaker.name}</p>
                }
                {(!(speaker.resume || speaker.linkedin_url) || agendaModalVisible) && 
                    <p className="p-0 my-0 event__speaker-name">{speaker.title} {speaker.firstname} {speaker.name}</p>
                }
                <p className="p-0 my-0 event__speaker-company"><small>{speaker.jobtitle} | {speaker.company}</small></p>
            </Col>
        </>
    );
}

export default SpeakerElement;